import type {
  CoachingTip,
  MetaField,
  NextStep,
} from "@repo/app-types/entities/liveCoaching";
import { IconSparkles } from "@tabler/icons-react";
import type { FC } from "react";
import { MarkdownContent } from "../markdown/markdownContent.js";
import { MetaFieldRow } from "./metaFieldRow.js";

export interface SummaryContentProps {
  coachingTips: readonly CoachingTip[] | undefined;
  summaryMarkdown: string | undefined;
  nextSteps: readonly NextStep[] | undefined;
  metaFields: readonly MetaField[] | undefined;
}

export const SummaryContent: FC<SummaryContentProps> = (props) => {
  // TODO: Maybe we need loading states?
  return (
    <div className="h-0 flex-auto overflow-y-auto px-4 py-3">
      {/* Coaching tips */}
      {props.coachingTips?.length ? (
        <div className="mb-4">
          <p className="mb-2 text-[10px] font-semibold text-indigo-500">
            For your next call
          </p>
          <div className="space-y-2">
            {props.coachingTips.map((tip, i) => (
              <div
                key={i}
                className="flex gap-2 rounded-lg bg-indigo-50 px-3 py-2.5"
              >
                <IconSparkles className="mt-0.5 size-3.5 shrink-0 text-indigo-400" />
                <p className="text-xs leading-relaxed text-foreground">
                  {tip.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {/* Call summary */}
      {props.summaryMarkdown ? (
        <div className="mb-4">
          <p className="mb-1.5 text-[10px] font-semibold text-slate-400">
            Summary
          </p>
          <div className="prose prose-sm">
            <MarkdownContent>{props.summaryMarkdown}</MarkdownContent>
          </div>
        </div>
      ) : null}

      {/* Next steps */}
      {props.nextSteps?.length ? (
        <div className="mb-4">
          <p className="mb-1.5 text-[10px] font-semibold text-slate-400">
            Next steps
          </p>
          <div className="space-y-1.5">
            {props.nextSteps.map((step, i) => (
              <div
                key={i}
                className="flex items-start gap-2 text-xs leading-relaxed text-muted-foreground"
              >
                <span className="mt-0.5 flex size-4 shrink-0 items-center justify-center rounded-full bg-indigo-100 text-[9px] font-bold text-indigo-600">
                  {i + 1}
                </span>
                {step.text}
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {/* Metafields */}
      {props.metaFields?.length ? (
        <div>
          <p className="mb-1 text-[10px] font-semibold text-slate-400">
            Fields
          </p>
          <div className="space-y-0.5">
            {props.metaFields.map((field, i) => (
              <MetaFieldRow key={i} label={field.label} value={field.value} />
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};
